import { IListElement } from 'app/services/api5-service/api.interface';
import { getButtonList } from 'components/form-button/form-button.utils';
import { IFormButtonUi } from 'components/form-button/model';

import { ISPFormState } from 'common/dynamic-form/model';

/**
 * Get row deafult button, for clickable state
 *
 * @param element - row meta
 * @param state
 */
export function getRowDefaultButton(
  element: IListElement,
  state: ISPFormState,
): IFormButtonUi | undefined {
  const defaultButton = element.default_action_button?.button;

  if (defaultButton) {
    const buttonUi = getButtonList(
      state.docSubject.value,
      [defaultButton],
      false,
    )[0];

    if (buttonUi.key) {
      buttonUi.keyValue = element[buttonUi.key]?.$;
    }

    return buttonUi;
  }
}
